import { render, staticRenderFns } from "./FileForm.vue?vue&type=template&id=aa403404&scoped=true"
import script from "./FileForm.vue?vue&type=script&lang=js"
export * from "./FileForm.vue?vue&type=script&lang=js"
import style0 from "./FileForm.vue?vue&type=style&index=0&id=aa403404&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa403404",
  null
  
)

export default component.exports